import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=bca228f4&scoped=true&"
import script from "./ModalBox.vue?vue&type=script&lang=ts&"
export * from "./ModalBox.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBox.vue?vue&type=style&index=0&id=bca228f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca228f4",
  null
  
)

export default component.exports